/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  BulkOrderContentsCreate,
  BulkOrderCreate,
  BulkOrderRead,
  ExportBulkOrdersParams,
  GetBulkOrdersParams,
  HTTPValidationError,
  PageBulkOrderManyRead,
  UpdateBulkOrderExternalIdParams,
  UpdateBulkOrderOrderedAtParams,
  UpdateBulkOrderPaymentCollectorIdParams,
} from "./fastAPI.schemas";

import { customInstance } from "../../axios";
import type { ErrorType } from "../../axios";

/**
 * Route to create a new bulk_order.
 * @summary Create Bulk Order
 */
export const createBulkOrder = (
  bulkOrderCreate: BulkOrderCreate,
  signal?: AbortSignal,
) => {
  return customInstance<string>({
    url: `/api/bulk_order/`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: bulkOrderCreate,
    signal,
  });
};

export const getCreateBulkOrderMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBulkOrder>>,
    TError,
    { data: BulkOrderCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createBulkOrder>>,
  TError,
  { data: BulkOrderCreate },
  TContext
> => {
  const mutationKey = ["createBulkOrder"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBulkOrder>>,
    { data: BulkOrderCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createBulkOrder(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateBulkOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof createBulkOrder>>
>;
export type CreateBulkOrderMutationBody = BulkOrderCreate;
export type CreateBulkOrderMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Create Bulk Order
 */
export const useCreateBulkOrder = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createBulkOrder>>,
      TError,
      { data: BulkOrderCreate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createBulkOrder>>,
  TError,
  { data: BulkOrderCreate },
  TContext
> => {
  const mutationOptions = getCreateBulkOrderMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to get many bulk_orders.

Results are paginated and filtered based on the current user's role.
 * @summary Get Bulk Orders
 */
export const getBulkOrders = (
  params?: GetBulkOrdersParams,
  signal?: AbortSignal,
) => {
  return customInstance<PageBulkOrderManyRead>({
    url: `/api/bulk_order/`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetBulkOrdersQueryKey = (params?: GetBulkOrdersParams) => {
  return ["api", "bulk_order", ...(params ? [params] : [])] as const;
};

export const getGetBulkOrdersQueryOptions = <
  TData = Awaited<ReturnType<typeof getBulkOrders>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetBulkOrdersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBulkOrders>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBulkOrdersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBulkOrders>>> = ({
    signal,
  }) => getBulkOrders(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBulkOrders>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetBulkOrdersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBulkOrders>>
>;
export type GetBulkOrdersQueryError = ErrorType<void | HTTPValidationError>;

export function useGetBulkOrders<
  TData = Awaited<ReturnType<typeof getBulkOrders>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: undefined | GetBulkOrdersParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBulkOrders>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBulkOrders>>,
          TError,
          Awaited<ReturnType<typeof getBulkOrders>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBulkOrders<
  TData = Awaited<ReturnType<typeof getBulkOrders>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetBulkOrdersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBulkOrders>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBulkOrders>>,
          TError,
          Awaited<ReturnType<typeof getBulkOrders>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBulkOrders<
  TData = Awaited<ReturnType<typeof getBulkOrders>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetBulkOrdersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBulkOrders>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Bulk Orders
 */

export function useGetBulkOrders<
  TData = Awaited<ReturnType<typeof getBulkOrders>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetBulkOrdersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBulkOrders>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetBulkOrdersQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to create many order_contents.

Note the separate order_contents crud file.
 * @summary Create Bulk Order Contents
 */
export const createBulkOrderContents = (
  bulkOrderId: string,
  bulkOrderContentsCreate: BulkOrderContentsCreate,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>({
    url: `/api/bulk_order/${bulkOrderId}/contents`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: bulkOrderContentsCreate,
    signal,
  });
};

export const getCreateBulkOrderContentsMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBulkOrderContents>>,
    TError,
    { bulkOrderId: string; data: BulkOrderContentsCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createBulkOrderContents>>,
  TError,
  { bulkOrderId: string; data: BulkOrderContentsCreate },
  TContext
> => {
  const mutationKey = ["createBulkOrderContents"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBulkOrderContents>>,
    { bulkOrderId: string; data: BulkOrderContentsCreate }
  > = (props) => {
    const { bulkOrderId, data } = props ?? {};

    return createBulkOrderContents(bulkOrderId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateBulkOrderContentsMutationResult = NonNullable<
  Awaited<ReturnType<typeof createBulkOrderContents>>
>;
export type CreateBulkOrderContentsMutationBody = BulkOrderContentsCreate;
export type CreateBulkOrderContentsMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Create Bulk Order Contents
 */
export const useCreateBulkOrderContents = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createBulkOrderContents>>,
      TError,
      { bulkOrderId: string; data: BulkOrderContentsCreate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createBulkOrderContents>>,
  TError,
  { bulkOrderId: string; data: BulkOrderContentsCreate },
  TContext
> => {
  const mutationOptions = getCreateBulkOrderContentsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Create a new draft bulk order cloned from an existing bulk order.
 * @summary Duplicate Bulk Order
 */
export const duplicateBulkOrder = (
  bulkOrderId: string,
  signal?: AbortSignal,
) => {
  return customInstance<string>({
    url: `/api/bulk_order/${bulkOrderId}/duplicate`,
    method: "POST",
    signal,
  });
};

export const getDuplicateBulkOrderMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof duplicateBulkOrder>>,
    TError,
    { bulkOrderId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof duplicateBulkOrder>>,
  TError,
  { bulkOrderId: string },
  TContext
> => {
  const mutationKey = ["duplicateBulkOrder"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof duplicateBulkOrder>>,
    { bulkOrderId: string }
  > = (props) => {
    const { bulkOrderId } = props ?? {};

    return duplicateBulkOrder(bulkOrderId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DuplicateBulkOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof duplicateBulkOrder>>
>;

export type DuplicateBulkOrderMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Duplicate Bulk Order
 */
export const useDuplicateBulkOrder = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof duplicateBulkOrder>>,
      TError,
      { bulkOrderId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof duplicateBulkOrder>>,
  TError,
  { bulkOrderId: string },
  TContext
> => {
  const mutationOptions = getDuplicateBulkOrderMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Export bulk orders to CSV with true streaming.
Processes and sends data in chunks without loading everything into memory.
Uses the same validation schema as the base GET endpoint.
 * @summary Export Bulk Orders
 */
export const exportBulkOrders = (
  params?: ExportBulkOrdersParams,
  signal?: AbortSignal,
) => {
  return customInstance<Blob>({
    url: `/api/bulk_order/export`,
    method: "GET",
    params,
    responseType: "blob",
    signal,
  });
};

export const getExportBulkOrdersQueryKey = (
  params?: ExportBulkOrdersParams,
) => {
  return ["api", "bulk_order", "export", ...(params ? [params] : [])] as const;
};

export const getExportBulkOrdersQueryOptions = <
  TData = Awaited<ReturnType<typeof exportBulkOrders>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: ExportBulkOrdersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportBulkOrders>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getExportBulkOrdersQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof exportBulkOrders>>
  > = ({ signal }) => exportBulkOrders(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof exportBulkOrders>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExportBulkOrdersQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportBulkOrders>>
>;
export type ExportBulkOrdersQueryError = ErrorType<void | HTTPValidationError>;

export function useExportBulkOrders<
  TData = Awaited<ReturnType<typeof exportBulkOrders>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: undefined | ExportBulkOrdersParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportBulkOrders>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportBulkOrders>>,
          TError,
          Awaited<ReturnType<typeof exportBulkOrders>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExportBulkOrders<
  TData = Awaited<ReturnType<typeof exportBulkOrders>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: ExportBulkOrdersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportBulkOrders>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportBulkOrders>>,
          TError,
          Awaited<ReturnType<typeof exportBulkOrders>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExportBulkOrders<
  TData = Awaited<ReturnType<typeof exportBulkOrders>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: ExportBulkOrdersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportBulkOrders>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Export Bulk Orders
 */

export function useExportBulkOrders<
  TData = Awaited<ReturnType<typeof exportBulkOrders>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: ExportBulkOrdersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportBulkOrders>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExportBulkOrdersQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to get an bulk_order by ID.

Results are filtered based on the current user's role.
 * @summary Get Bulk Order
 */
export const getBulkOrder = (bulkOrderId: string, signal?: AbortSignal) => {
  return customInstance<BulkOrderRead>({
    url: `/api/bulk_order/${bulkOrderId}`,
    method: "GET",
    signal,
  });
};

export const getGetBulkOrderQueryKey = (bulkOrderId?: string) => {
  return ["api", "bulk_order", bulkOrderId] as const;
};

export const getGetBulkOrderQueryOptions = <
  TData = Awaited<ReturnType<typeof getBulkOrder>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkOrderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBulkOrder>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBulkOrderQueryKey(bulkOrderId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBulkOrder>>> = ({
    signal,
  }) => getBulkOrder(bulkOrderId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!bulkOrderId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getBulkOrder>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetBulkOrderQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBulkOrder>>
>;
export type GetBulkOrderQueryError = ErrorType<void | HTTPValidationError>;

export function useGetBulkOrder<
  TData = Awaited<ReturnType<typeof getBulkOrder>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkOrderId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBulkOrder>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBulkOrder>>,
          TError,
          Awaited<ReturnType<typeof getBulkOrder>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBulkOrder<
  TData = Awaited<ReturnType<typeof getBulkOrder>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkOrderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBulkOrder>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBulkOrder>>,
          TError,
          Awaited<ReturnType<typeof getBulkOrder>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBulkOrder<
  TData = Awaited<ReturnType<typeof getBulkOrder>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkOrderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBulkOrder>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Bulk Order
 */

export function useGetBulkOrder<
  TData = Awaited<ReturnType<typeof getBulkOrder>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkOrderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBulkOrder>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetBulkOrderQueryOptions(bulkOrderId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to update an bulk_order by ID.
 * @summary Update Bulk Order
 */
export const updateBulkOrder = (
  bulkOrderId: string,
  bulkOrderCreate: BulkOrderCreate,
) => {
  return customInstance<string>({
    url: `/api/bulk_order/${bulkOrderId}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: bulkOrderCreate,
  });
};

export const getUpdateBulkOrderMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBulkOrder>>,
    TError,
    { bulkOrderId: string; data: BulkOrderCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateBulkOrder>>,
  TError,
  { bulkOrderId: string; data: BulkOrderCreate },
  TContext
> => {
  const mutationKey = ["updateBulkOrder"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateBulkOrder>>,
    { bulkOrderId: string; data: BulkOrderCreate }
  > = (props) => {
    const { bulkOrderId, data } = props ?? {};

    return updateBulkOrder(bulkOrderId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateBulkOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateBulkOrder>>
>;
export type UpdateBulkOrderMutationBody = BulkOrderCreate;
export type UpdateBulkOrderMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Update Bulk Order
 */
export const useUpdateBulkOrder = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateBulkOrder>>,
      TError,
      { bulkOrderId: string; data: BulkOrderCreate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateBulkOrder>>,
  TError,
  { bulkOrderId: string; data: BulkOrderCreate },
  TContext
> => {
  const mutationOptions = getUpdateBulkOrderMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to delete a bulk_order by ID.
 * @summary Delete Bulk Order
 */
export const deleteBulkOrder = (bulkOrderId: string) => {
  return customInstance<unknown>({
    url: `/api/bulk_order/${bulkOrderId}`,
    method: "DELETE",
  });
};

export const getDeleteBulkOrderMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBulkOrder>>,
    TError,
    { bulkOrderId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteBulkOrder>>,
  TError,
  { bulkOrderId: string },
  TContext
> => {
  const mutationKey = ["deleteBulkOrder"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteBulkOrder>>,
    { bulkOrderId: string }
  > = (props) => {
    const { bulkOrderId } = props ?? {};

    return deleteBulkOrder(bulkOrderId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteBulkOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteBulkOrder>>
>;

export type DeleteBulkOrderMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Delete Bulk Order
 */
export const useDeleteBulkOrder = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteBulkOrder>>,
      TError,
      { bulkOrderId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteBulkOrder>>,
  TError,
  { bulkOrderId: string },
  TContext
> => {
  const mutationOptions = getDeleteBulkOrderMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to get a PDF purchase order for a bulk_order by ID.
 * @summary Get Purchase Order
 */
export const getPurchaseOrder = (bulkOrderId: string, signal?: AbortSignal) => {
  return customInstance<Blob>({
    url: `/api/bulk_order/${bulkOrderId}/purchase_order`,
    method: "GET",
    responseType: "blob",
    signal,
  });
};

export const getGetPurchaseOrderQueryKey = (bulkOrderId?: string) => {
  return ["api", "bulk_order", bulkOrderId, "purchase_order"] as const;
};

export const getGetPurchaseOrderQueryOptions = <
  TData = Awaited<ReturnType<typeof getPurchaseOrder>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkOrderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPurchaseOrder>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPurchaseOrderQueryKey(bulkOrderId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPurchaseOrder>>
  > = ({ signal }) => getPurchaseOrder(bulkOrderId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!bulkOrderId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPurchaseOrder>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPurchaseOrderQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPurchaseOrder>>
>;
export type GetPurchaseOrderQueryError = ErrorType<void | HTTPValidationError>;

export function useGetPurchaseOrder<
  TData = Awaited<ReturnType<typeof getPurchaseOrder>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkOrderId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPurchaseOrder>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPurchaseOrder>>,
          TError,
          Awaited<ReturnType<typeof getPurchaseOrder>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPurchaseOrder<
  TData = Awaited<ReturnType<typeof getPurchaseOrder>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkOrderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPurchaseOrder>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPurchaseOrder>>,
          TError,
          Awaited<ReturnType<typeof getPurchaseOrder>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPurchaseOrder<
  TData = Awaited<ReturnType<typeof getPurchaseOrder>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkOrderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPurchaseOrder>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Purchase Order
 */

export function useGetPurchaseOrder<
  TData = Awaited<ReturnType<typeof getPurchaseOrder>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkOrderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPurchaseOrder>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPurchaseOrderQueryOptions(bulkOrderId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to update external_id of a bulk order.
 * @summary Update Bulk Order External Id
 */
export const updateBulkOrderExternalId = (
  bulkOrderId: string,
  params: UpdateBulkOrderExternalIdParams,
) => {
  return customInstance<unknown>({
    url: `/api/bulk_order/${bulkOrderId}/external_id`,
    method: "PUT",
    params,
  });
};

export const getUpdateBulkOrderExternalIdMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBulkOrderExternalId>>,
    TError,
    { bulkOrderId: string; params: UpdateBulkOrderExternalIdParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateBulkOrderExternalId>>,
  TError,
  { bulkOrderId: string; params: UpdateBulkOrderExternalIdParams },
  TContext
> => {
  const mutationKey = ["updateBulkOrderExternalId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateBulkOrderExternalId>>,
    { bulkOrderId: string; params: UpdateBulkOrderExternalIdParams }
  > = (props) => {
    const { bulkOrderId, params } = props ?? {};

    return updateBulkOrderExternalId(bulkOrderId, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateBulkOrderExternalIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateBulkOrderExternalId>>
>;

export type UpdateBulkOrderExternalIdMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Update Bulk Order External Id
 */
export const useUpdateBulkOrderExternalId = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateBulkOrderExternalId>>,
      TError,
      { bulkOrderId: string; params: UpdateBulkOrderExternalIdParams },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateBulkOrderExternalId>>,
  TError,
  { bulkOrderId: string; params: UpdateBulkOrderExternalIdParams },
  TContext
> => {
  const mutationOptions = getUpdateBulkOrderExternalIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to update a bulk order's ordered_at datetime.
 * @summary Update Bulk Order Ordered At
 */
export const updateBulkOrderOrderedAt = (
  bulkOrderId: string,
  params: UpdateBulkOrderOrderedAtParams,
) => {
  return customInstance<unknown>({
    url: `/api/bulk_order/${bulkOrderId}/ordered_at`,
    method: "PUT",
    params,
  });
};

export const getUpdateBulkOrderOrderedAtMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBulkOrderOrderedAt>>,
    TError,
    { bulkOrderId: string; params: UpdateBulkOrderOrderedAtParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateBulkOrderOrderedAt>>,
  TError,
  { bulkOrderId: string; params: UpdateBulkOrderOrderedAtParams },
  TContext
> => {
  const mutationKey = ["updateBulkOrderOrderedAt"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateBulkOrderOrderedAt>>,
    { bulkOrderId: string; params: UpdateBulkOrderOrderedAtParams }
  > = (props) => {
    const { bulkOrderId, params } = props ?? {};

    return updateBulkOrderOrderedAt(bulkOrderId, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateBulkOrderOrderedAtMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateBulkOrderOrderedAt>>
>;

export type UpdateBulkOrderOrderedAtMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Update Bulk Order Ordered At
 */
export const useUpdateBulkOrderOrderedAt = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateBulkOrderOrderedAt>>,
      TError,
      { bulkOrderId: string; params: UpdateBulkOrderOrderedAtParams },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateBulkOrderOrderedAt>>,
  TError,
  { bulkOrderId: string; params: UpdateBulkOrderOrderedAtParams },
  TContext
> => {
  const mutationOptions = getUpdateBulkOrderOrderedAtMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to update payment_collector_id of a bulk order.
 * @summary Update Bulk Order Payment Collector Id
 */
export const updateBulkOrderPaymentCollectorId = (
  bulkOrderId: string,
  params?: UpdateBulkOrderPaymentCollectorIdParams,
) => {
  return customInstance<unknown>({
    url: `/api/bulk_order/${bulkOrderId}/payment_collector_id`,
    method: "PUT",
    params,
  });
};

export const getUpdateBulkOrderPaymentCollectorIdMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBulkOrderPaymentCollectorId>>,
    TError,
    { bulkOrderId: string; params?: UpdateBulkOrderPaymentCollectorIdParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateBulkOrderPaymentCollectorId>>,
  TError,
  { bulkOrderId: string; params?: UpdateBulkOrderPaymentCollectorIdParams },
  TContext
> => {
  const mutationKey = ["updateBulkOrderPaymentCollectorId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateBulkOrderPaymentCollectorId>>,
    { bulkOrderId: string; params?: UpdateBulkOrderPaymentCollectorIdParams }
  > = (props) => {
    const { bulkOrderId, params } = props ?? {};

    return updateBulkOrderPaymentCollectorId(bulkOrderId, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateBulkOrderPaymentCollectorIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateBulkOrderPaymentCollectorId>>
>;

export type UpdateBulkOrderPaymentCollectorIdMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Update Bulk Order Payment Collector Id
 */
export const useUpdateBulkOrderPaymentCollectorId = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateBulkOrderPaymentCollectorId>>,
      TError,
      { bulkOrderId: string; params?: UpdateBulkOrderPaymentCollectorIdParams },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateBulkOrderPaymentCollectorId>>,
  TError,
  { bulkOrderId: string; params?: UpdateBulkOrderPaymentCollectorIdParams },
  TContext
> => {
  const mutationOptions =
    getUpdateBulkOrderPaymentCollectorIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to send a purchase order email for a bulk order to a list of email addresses.
 * @summary Send Purchase Order Email
 */
export const sendPurchaseOrderEmail = (
  bulkOrderId: string,
  sendPurchaseOrderEmailBody: string[],
  signal?: AbortSignal,
) => {
  return customInstance<unknown>({
    url: `/api/bulk_order/${bulkOrderId}/send_purchase_order_email`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: sendPurchaseOrderEmailBody,
    signal,
  });
};

export const getSendPurchaseOrderEmailMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendPurchaseOrderEmail>>,
    TError,
    { bulkOrderId: string; data: string[] },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendPurchaseOrderEmail>>,
  TError,
  { bulkOrderId: string; data: string[] },
  TContext
> => {
  const mutationKey = ["sendPurchaseOrderEmail"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendPurchaseOrderEmail>>,
    { bulkOrderId: string; data: string[] }
  > = (props) => {
    const { bulkOrderId, data } = props ?? {};

    return sendPurchaseOrderEmail(bulkOrderId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendPurchaseOrderEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendPurchaseOrderEmail>>
>;
export type SendPurchaseOrderEmailMutationBody = string[];
export type SendPurchaseOrderEmailMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Send Purchase Order Email
 */
export const useSendPurchaseOrderEmail = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof sendPurchaseOrderEmail>>,
      TError,
      { bulkOrderId: string; data: string[] },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof sendPurchaseOrderEmail>>,
  TError,
  { bulkOrderId: string; data: string[] },
  TContext
> => {
  const mutationOptions = getSendPurchaseOrderEmailMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
